import pyFormGroup from 'pylon-vue/src/components/form-group/form-group'

const sFormGroup = {
    name: 'sFormGroup',
    extends: pyFormGroup,
    beforeMount(){
        //set a multiple class on form group
        this.$on("pyYesNoRadio", function(val){
            this.stateClassObj.multiple = val
        })
    }
}

export default sFormGroup